import Blogs from "../app/Blogs";
import Categories from "../app/Categories";
import Footer from "../../components/app/Footer";
import HireTalent from "../app/HireTalent";
import Navbar from "../navigation/Navbar";
import DailyJobsDesc from "./DailyJobsDesc";
import PostTalent from "./PostTalent";
import Tips from "./Tips";

function JobHome() {
    return (
        <div>
            <Navbar selected='Home'></Navbar>
            <DailyJobsDesc></DailyJobsDesc>
            <PostTalent></PostTalent>
            <HireTalent></HireTalent>
            <Tips></Tips>
            <Blogs style={{background: '#FFF'}}></Blogs>
            <Categories></Categories>
            <Footer></Footer>
        </div>
    );
}

export default JobHome;